// extracted by mini-css-extract-plugin
export default {"table_annotationsHeading":"AdminViewOneUserTable_table_annotationsHeading__2GDYR","table":"AdminViewOneUserTable_table__u5Jk-"};